module.exports = __webpack_public_path__ + "img/brandon-smith.909696b6.jpg";